
















































import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import axiosInstance from "../../../axios";
import TableColumn from "./Table/TableColumn.vue";
import TableTotal from "./Table/TableTotal.vue";
import Table from "./Table/Table.vue";
import CustomDropdown from "../../Widgets/Forms/CustomDropdown.vue";
import {Form} from "../../../../types/forms";
// @ts-ignore
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/material_blue.css';
import { Russian } from "flatpickr/dist/l10n/ru.js";
import * as dayjs from 'dayjs'

type Pack = {
    id: number,
    name: string
}

type Activity = Pack & {
    contentPacks: {[key: string]: Pack},
}

type Invite = {
    code: string
}

type StatisticItem = {
    activity_id: number,
    content_pack_id: number,
    duration: number,
    players_count: string
}

@Component({
    components: {CustomDropdown, Table, TableTotal, TableColumn, flatPickr},
})

export default class IdentificationTag extends Vue {
    @Prop({required: true}) private readonly tag!: string;
    private readonly TOTAL_REPORT = 'total';
    private activities: null|{[key: number]: Activity} = null;
    private totalInfo : Record<string, Array<StatisticItem>>|null = null;
    private codes: Array<Record<string, Array<StatisticItem>>> = [];
    private gameFilterValue: Form.SelectValue|null = null;
    private packFilterValue: Form.SelectValue|null = null;
    private isLoading: boolean = false;
    private date: string = '';
    private config: any = {
        locale: Russian,
        dateFormat: 'Y-m-d',
        mode: 'range',
        defaultDate: this.date,
    };
    private dateFrom: string = '';
    private dateTo: string = '';

    private START_PAGE = 'Start page';
    private SANDBOX = 'Sandbox';


    mounted(): void {
        this.getActivitiesList().then((response: any) => {
            this.activities = response.response;
        });

        this.updateInfo();
    }

    /**
     * Список игр для фильтров
     * @private
     */
    private get activitiesForFilter(): Array<Form.SelectValue>|null
    {
        if (!this.activities) {
            return null;
        }

        let activities: Array<Form.SelectValue> = [];
        activities.push({value: 'menu', label: this.START_PAGE});
        activities.push({value: '0', label: this.SANDBOX});

        for (let activity in this.activities) {
            activities.push({value: this.activities[activity].id.toString(), label: this.activities[activity].name});
        }

        return activities;
    }

    /**
     * Список паков для фильтров
     * @private
     */
    private get packsForFilter(): Array<Form.SelectValue>|null
    {
        if (!this.gameFilterValue
            || !this.activities
            || this.gameFilterValue.label === this.SANDBOX
            || this.gameFilterValue.label === this.START_PAGE)
        {
            return null;
        }

        let packs: Array<Form.SelectValue> = [];
        // @ts-ignore
        const activityPacks: {[key: string]: Pack} = this.activities[this.gameFilterValue.value].contentPacks;

        for (let pack in activityPacks) {
            packs.push({value: activityPacks[pack].id.toString(), label: activityPacks[pack].name});
        }

        return packs;
    }

    /**
     * Обновить информацию по статистике
     */
    private updateInfo(): void
    {
        this.codes = [];
        this.getInvitesList().then((response: any) => {
            let codes = response.response;

            codes.forEach((code: any) => {
                this.getCodeReport(code.code).then((data) => {
                    const codeData = {};
                    // @ts-ignore
                    codeData[code.code] = (data as any).response.data as {[key: string]: Array<StatisticItem>};
                    this.codes.push(codeData);
                });
            });
        });

        this.totalInfo = null;
        this.getCodeReport(this.TOTAL_REPORT).then((data: any) => {
            this.totalInfo = data.response.data;
            if (this.totalInfo) {
                // @ts-ignore
                this.codes.unshift({total: this.totalInfo});
            }
        });
    }

    /**
     * Сбросить фильтры
     * @private
     */
    private resetFilters(): void
    {
        this.gameFilterValue = null;
        this.packFilterValue = null;
        this.clearDate();
        (this.$refs.activitiesDropdown as CustomDropdown)?.resetValue();
        (this.$refs.packsDropdown as CustomDropdown)?.resetValue();
        this.updateInfo();
    }

    /**
     * Изменить значение выбранного фильтра по названию игры
     * @param value
     * @private
     */
    private changeGameFilterValue(value: Form.SelectValue): void
    {
        this.gameFilterValue = value;
        this.updateInfo();
    }

    /**
     * Изменить значение выбранного фильтра по названию пака
     * @param value
     * @private
     */
    private changePackFilterValue(value: Form.SelectValue): void
    {
        this.packFilterValue = value;
        this.updateInfo();
    }

    /**
     * Список игр с контент-паками
     * @private
     */
    private getActivitiesList(): Promise<{[key: number]: Activity}>
    {
        return new Promise((resolve, reject) => {
            axiosInstance.get(`/statistics/activity/list`)
                .then(response => {
                    if (typeof response.data.errors === 'undefined') {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                }).catch(error => {
                reject(error);
            });
        });
    }

    /**
     * Список инвайтов
     * @private
     */
    private getInvitesList(): Promise<Array<Invite>>
    {
        return new Promise((resolve, reject) => {
            axiosInstance.get(`/statistics/invite/list/${this.tag}`)
                .then(response => {
                    if (typeof response.data.errors === 'undefined') {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                }).catch(error => {
                reject(error);
            });
        });
    }

    /**
     * Отчет по коду инвайта
     * @param code
     * @private
     */
    private getCodeReport(code: string)
    {
        const params = new URLSearchParams();
        if (this.gameFilterValue) {
            params.append('activity_id', this.gameFilterValue.value);
        }
        if (this.packFilterValue) {
            params.append('content_pack_id', this.packFilterValue.value);
        }
        if (this.dateFrom) {
            params.append('date_from', this.dateFrom);
        }
        if (this.dateTo) {
            params.append('date_to', this.dateTo);
        }

        return new Promise((resolve, reject) => {
            axiosInstance.get(`/statistics/invite/report/${this.tag}/${code}`, {params})
                .then(response => {
                    if (typeof response.data.errors === 'undefined') {
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                }).catch(error => {
                reject(error);
            });
        });
    }

    /**
     * Изменить дату в календаре
     * @param selectedDates
     * @private
     */
    private changeDate(selectedDates: any): void
    {
        // @ts-ignore
        this.dateFrom = typeof selectedDates[0] !== 'undefined' ? dayjs(selectedDates[0]).format('YYYY-MM-DD') : '';
        // @ts-ignore
        this.dateTo = typeof selectedDates[1] !== 'undefined' ? dayjs(selectedDates[1]).format('YYYY-MM-DD') : '';
    }

    /**
     * Очистить календарь
     * @private
     */
    private clearDate(): void
    {
        this.dateFrom = '';
        this.dateTo = '';
        this.date = '';
    }
}
